import {
	addFeatureFromInfos,
	getLayerByName
} from "../containers/utils/carto";

/**
 * Will change the clicked cell feature on targeted map 
 * @param {ol.map} map to update
 * @param {object} infos from getFeatureInfo to display
 */
export const changeClickedCell = (map, infos) => {
    let layer = getLayerByName(map, "selectedLayer");		
    let layerSource = layer.getSource();
    layerSource.clear();
    if(infos) {
        layer.setVisible(true);
        addFeatureFromInfos(infos, layerSource, map);
    }
}

/** * Draws a point on the canvas
 * @param {CanvasRenderingContext2D} ctx - The canvas context to draw on
 * @param {number} size - The size of the canvas
 * @param {object} p - The properties of the point to draw
 */
export const drawPoint = (ctx, size, p) => {
  const radius = (p.size || 10) / 2;
  const center = size / 2;

  ctx.beginPath();
  ctx.arc(center, center, radius, 0, 2 * Math.PI);
  ctx.fillStyle = p.fill || '#000';
  ctx.globalAlpha = parseFloat(p['fill-opacity'] || 1);
  ctx.fill();

  if (p.stroke) {
    ctx.strokeStyle = p.stroke;
    ctx.lineWidth = parseFloat(p['stroke-width'] || 1);
    ctx.stroke();
  }

  ctx.globalAlpha = 1;
}

/** * Draws a line on the canvas
 * @param {CanvasRenderingContext2D} ctx - The canvas context to draw on
 * @param {number} size - The size of the canvas
 * @param {object} l - The properties of the line to draw
 */
export const drawLine = (ctx, size, l) => {
  ctx.beginPath();
  ctx.moveTo(5, size / 2);
  ctx.lineTo(size - 5, size / 2);
  ctx.strokeStyle = l.stroke || '#000';
  ctx.lineWidth = parseFloat(l['stroke-width'] || 2);
  ctx.stroke();
}

/** * Draw a polygon on the canvas
 * @param {CanvasRenderingContext2D} ctx - The canvas context to draw on
 * @param {number} size - The size of the canvas
 * @param {object} poly - The properties of the polygon to draw
 */
export const drawPolygon = (ctx, size, poly) => {
  const padding = 1;
  const boxSize = size - 2 * padding;

  ctx.fillStyle = poly.fill || '#000';
  ctx.globalAlpha = parseFloat(poly['fill-opacity'] || 0);
  ctx.fillRect(padding, padding, boxSize, boxSize);
  ctx.globalAlpha = 1;
}
